import { render, staticRenderFns } from "./SystemChart.vue?vue&type=template&id=f0bcd4e8&scoped=true"
import script from "./SystemChart.vue?vue&type=script&lang=js"
export * from "./SystemChart.vue?vue&type=script&lang=js"
import style0 from "./SystemChart.vue?vue&type=style&index=0&id=f0bcd4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bcd4e8",
  null
  
)

export default component.exports